<template>
 <div class="card role">
      <div class="card-header bg-transparent">
        <div class="row align-items-center">
            <div class="col-md-6">
              <h3>Customers</h3>
            </div>
            <div class="col cyanb">
              <i class="fas fa-users"></i>
              <!-- <span>{{totalCustomerCount}}</span> -->
              <span>{{tweened.toFixed(0)}}</span>

            </div>
            <div class="text-right" v-if="isAdmin || isEditor">
              <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i></a>
            </div>
        </div>
      </div>
  </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import gsap from 'gsap'

export default {
  name: "customersWidget",
  data() {
    return {
      totalCustomerCount : 0,
      tweened: 0,
      isAdmin: false,
      isTrader : false,
      isEditor : false
    };
  },
  watch: {
    totalCustomerCount(n) {
      gsap.to(this, { duration: 0.5, tweened: Number(n) || 0 })
    }
  },
  methods: {
    navigateListPage(){
      window.location.href = "/ims/ims-customers";
    },
    getCustomerCount(){
      this.loading = true;
      const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
      .get(
        config.baseUrlBidSide +
            "/customer/list?page=1&size=10&search=&status=ACTIVE&sortColumn=customerFirstName&sortOrder=ASC",
          auth
      )
      .then(result => {
        this.totalCustomerCount = result.data.pageInfo.totalElements
        this.loading = false;
      })

    },
  },
  mounted() {
    this.getCustomerCount();
    this.$cognitoAuth.getUserGroup((err, role) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        //console.log(role)
        this.tenantName = role[0].split("-")[0];
        var roleArray = role.map(item => {
          return  item.split("-")[1];
        })
        roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
        roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
        roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
       // this.getOfferStatus();

      }
      //console.log("isa",this.isAdmin);
    });

  }
};
</script>